import * as React from 'react';
import { compose, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';
import { PasswordChangeForm } from './PasswordChangeForm';
import { FadeTranslate } from 'ui/transitions';
import { LanguagePicker } from '../main/header/LanguagePicker';

import './PasswordChangeScreen.css';

export type Props = {
    isPasswordResetRequired: boolean;
};

const fadeFrom = { y: '100%' };
const fadeTo = { y: '0%' };

export const RawPasswordChangeScreen = ({ isPasswordResetRequired, copyright, styles }: Props & RecomposeProps & OemProps) =>
    <div
        id="passwordChange-screen"
        className={ !isPasswordResetRequired ? 'not-required' : undefined }
        style={ styles.Workspace }
    >
        <LanguagePicker/>
    
        <div id="passwordChange-form-host">
            <PasswordChangeForm visible={ isPasswordResetRequired }/>

            <FadeTranslate
                visible={ isPasswordResetRequired }
                from={ fadeFrom }
                to={ fadeTo }
                duration={ 200 }
            >
                <p
                    className="copyright"
                    style={ styles.copyright }
                    dangerouslySetInnerHTML={ copyright }
                />
            </FadeTranslate>
        </div>
    </div>
;

type RecomposeProps = {
    copyright: {
        __html: string;
    };
};

export const PasswordChangeScreen = compose<Props & RecomposeProps & OemProps, Props>(
    translate(),
    skin,
    withProps(({ t, styles }: TranslateProps & OemProps) => ({
        styles: {
            copyright: {
                color: styles.Window.color,
            },
        },
        copyright: {
            __html: t('OEM_CopyrightWebClient', [ new Date().getFullYear().toString() ]).replace(/\\n/g, ' '),
        },
    })),
)(RawPasswordChangeScreen);



// WEBPACK FOOTER //
// ./src/ui/password_change/PasswordChangeScreen.tsx